import {
  useAxios,
  useHandleApiError,
} from '@sttedra_ui/framework';

import ProvinceApiResponseModel from './province.api-response-model.js';

// #region Globals
const {base} = useAxios();
const CONTEXT_BASE_PATH = 'provincia';
const DEFAULT_TIMEOUT = 5000;
const {handleApiError} = useHandleApiError();
// #endregion

// #region Public functions
async function getAllRegionProvinces(throwError = true) {
  try {
    const url = '/' + CONTEXT_BASE_PATH;

    const {data: originalData} = await base.get(url, {
      timeout: DEFAULT_TIMEOUT,
    });

    function getRegions(provs) {
      const res = [];
      provs.forEach((p) => {
        if (!res.find((el) => el === p.region)) {
          res.push(p.region);
        }
      });
      return res.sort().map((n) => {
        return {name: n};
      });
    }
    const data = originalData.map((u) => new ProvinceApiResponseModel(u));
    const regions = getRegions(data);
    return {provinces: data, regions};
  } catch (err) {
    if (!throwError) {
      return handleApiError(err);
    }
    throw err;
  }
}
// #endregion

// #region Private functions
// ...
// #endregion

export {
  getAllRegionProvinces,
};
